module.exports = __webpack_public_path__ + "7f9c2eae70af273b0d5ddc4d9ef621ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/cover-1.jpg
// module id = 170
// module chunks = 0